/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Utils from '@/common/utils/utils';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { masterKnowledgeHyperLinkAtom } from '@/state/atom/ticketKnowledgeAtom';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import { getUserListByProjectAtom, userAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import { isPermissionAddItemTagOfCreateTicket } from '@/component/formManagement/handler/CommonHandler';
import Constant from '@/common/constant/Constant';
import { buildItemTagList } from '@/component/formManagement/addField/handler/MasterKnowledgeHandler';
import { queryFieldChild } from '@/service/formManagementService';
import API from '@aws-amplify/api';
import SystemField from '@/common/constant/SystemField';
import { cloneDeep } from 'lodash';
import RenderTooltipTitles from './RenderTooltipTitles';
import { Autocomplete } from '@material-ui/lab';
import { Box, Checkbox, Chip, FormControlLabel, Popover, Popper, Radio, RadioGroup, TextField, Tooltip, Typography, withStyles } from '@material-ui/core';
import UnCheckIconWhite from '../../project/settingCategory/UnCheckIconWhite';
import CheckedIcon from '../../project/settingCategory/CheckedIcon';
import { onClickMasterKnowledgeItem } from '@/component/formManagement/addField/handler/MasterKnowledgeHandler';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import _ from "lodash"

const getTooltipTitle = (item,argsCommon )=> {
    if(item.isDisplayLink){
    return (
        <div
            onClick={e => {
                e.stopPropagation();
                onClickMasterKnowledgeItem(argsCommon, {
                    title: item.title,
                    id: item.value
                });
            }}
        >
            <a href="javascript:void(0)">{item.title}</a>
        </div>
    );
    }else{
      return <div><a href="javascript:void(0)">{item.title}</a></div>
    }
};

const CustomToolTitle = props => {
    const { children, item, argsCommon, placement = 'top-start' } = props;
    const TextOnlyTooltip = withStyles({
        tooltip: {
            backgroundColor: 'white',
            border: '1px solid',
            minHeight: '30px',
            verticalAlign: 'middle',
            paddingTop: '7px',
            minWidth: '70px',
            textAlign: 'center',
            boxShadow: '0.25px 0.25px 1.5px 1.5px #AAA',
            textDecoration: 'underline',
            margin: 0,
            zIndex: '100001'
        }
    })(Tooltip);

    if (item.isDisplayLink) {
        return (
            <TextOnlyTooltip
                interactive
                title={getTooltipTitle(item, argsCommon)}
                placement={placement}
            >
                {children}
            </TextOnlyTooltip>
        );
    } else {
        return (
            <Tooltip title={item.title} placement={placement}>
                {children}
            </Tooltip>
        );
    }
};


export default function MenuMasterKnowledgeTagInPutBase(props) {
    const [validateError, setValidateError] = useState(props.data?.error);
    const [tagList, setTagList] = useState([]);
    const [tagValue, setTagValue] = useState([]);
    const [enableShowMore, setEnableShowMore] = useState(false);
    const [showAddItemInput, setShowAddItemInput] = useState(false);
    const [numOfRecordDisplay, setNumOfRecordDisplay] = useState(props.data.structure.recordNumber);
    const [firstRender, setFirstRender] = useState(true)
    const [defaultIndexChecked, setDefaultIndexChecked] = useState(0);
    const [isDoneInitData, setIsDoneInitData] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelListRecoilState, setPanelListRecoilState] = useRecoilState(multiPanelAtom);
    const [masterKnowledgeHyperLink, setMasterKnowledgeHyperLink] = useRecoilState(masterKnowledgeHyperLinkAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const [nextToken, setNextToken] = useState(null);
    const [originItemList, setOriginItemList] = useState([]);
    const [errorsAddItem, setErrorsAddItem] = useState('');
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    // common projectInuse state
    const projectDetail = props?.projectDetail;
    const isProjectManager = props?.isProjectManager;
    let userListOfProject = props?.userListOfProject;
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [isPermissionAddItemTag, setIsPermissionAddItemTag] = useState(false);
    let argsCommon = {
        API: props?.API,
        isNotAuthen: props?.isNotAuthen,
        tagField: props.data,
        userDetail: userDetail,
        corporationDetail: corporationDetail,
        projectDetail: projectDetail,
        userListOfProject: userListOfProject,
        originItemList: originItemList,
        setOriginItemList: setOriginItemList,
        // listProjectOfUser: listProjectOfUser,
        isPermissionAddItemTag: isPermissionAddItemTag,
        setIsPermissionAddItemTag: setIsPermissionAddItemTag,
        isProjectManager,
        tagList,
        setTagList,
        tagValue,
        setTagValue,
        defaultValue: Utils.isEmpty(props.defaultValue)
            ? []
            : Utils.convertJSONDataToObject(props.defaultValue),
        setDefaultIndexChecked,
        addNewPanel,

        panelListRecoilState,
        setPanelListRecoilState,

        masterKnowledgeHyperLink,
        setMasterKnowledgeHyperLink,

        projectList: projectList,
        b2bCustomerList: props?.b2bCustomerList,
        b2bSupportList: props?.b2bSupportList,
        panelId: props.panelId,
        panelList: props.panelList,
        setIsLoading: props.setIsLoading,
        setLastUserAction,
        enableShowMore,
        nextToken,
        setNextToken
    };

    const PopperComponentMemo = useMemo(() => {
        return ({ style, ...props }) => (
            <Popper
                {...props}
                style={{ ...style }} // width is passed in 'style' prop
                className="selectDrop tag-field-multi-select"
            />
        );
    }, []);
    

    useEffect(() => {
        // check permission add item tag when create ticket
        isPermissionAddItemTagOfCreateTicket(argsCommon);
    }, [props.data]);

    useEffect(() => {
        props.register(props.name);
        let tagField = argsCommon.tagField;
        switch (tagField.structure.settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                buildItemTagList(argsCommon, setIsDoneInitData,{
                    userDetail: userDetail,
                    projectDetail: projectDetail,
                    corporationDetail: corporationDetail
                })
                break;
            default:
                // HERE
                queryFieldChild(API, props.data.affiliationOrganization, props.data.id, props.data).then(
                    result => {
                        const systemTagChildList = SystemField.filter(
                            item =>
                                item.usage === Constant.FORM_USAGE.TAG &&
                                item.affiliationField === props.data.id
                        );

                        let tagItemListByFilter = [];
                        if (!Utils.isEmptyArray(result)) {
                            result.forEach(item => {
                                let structure = Utils.isEmpty(item.structure)
                                    ? {}
                                    : Utils.convertJSONDataToObject(item.structure);
                                if (structure.isShowItemInTicket) {
                                    tagItemListByFilter.push(item);
                                }
                            });
                        }
                        const tagChildList = !Utils.isEmptyArray(tagItemListByFilter)
                            ? tagItemListByFilter.concat(systemTagChildList)
                            : systemTagChildList;

                        let resFormatTagList = formatTagList(tagChildList);
                        let displayOrder = props.data?.structure?.displayOrder;
                        let tagListSorted = [];
                        switch (displayOrder) {
                            case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                                tagListSorted = resFormatTagList.sort(sortItemWithHitNumber);
                                break;
                            case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                                tagListSorted = resFormatTagList.sort((a, b) => {
                                    let nameA = a.title;
                                    let nameB = b.title;
                                    return nameA.localeCompare(nameB);
                                });
                                break;
                            case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
                            default:
                                tagListSorted = resFormatTagList.sort((item1, item2) => {
                                    return item1.no - item2.no;
                                });
                                break;
                        }
                        let listOptionItemTagField = [...tagListSorted];

                        if(!props.data.structure.isMultiple){
                            listOptionItemTagField = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...tagListSorted]
                        }
                        setTagList([...listOptionItemTagField]);
                        if ([...tagListSorted].length > 0 && props?.setIsTagList) {
                            props?.setIsTagList(true);
                        }

                        // default checked first item of list item if single choice
                        if (
                            !props.data.structure.isMultiple
                        ) {
                            setTagValue(Constant.FIELD_UI_SELECT_DEFAULT_ITEM)
                        }

                        if (props.defaultValue) {
                            const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);

                            if (!Utils.isEmptyArray(defaultValue)) {
                                let listDefaultValue = [];
                                defaultValue.forEach(tagSelected => {
                                    if (typeof tagSelected === 'string') {
                                        listDefaultValue.push(tagSelected);
                                    } else if (typeof tagSelected === 'object' && !Utils.isEmptyObject(tagSelected)) {
                                        listDefaultValue.push(tagSelected.value);
                                    }
                                })

                                let listDefaultSelectTag = resFormatTagList.filter(tag => {
                                    if (listDefaultValue.includes(tag.value)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                });

                                setTagValue([...listDefaultSelectTag]);
                                props.setValue(props?.name, [...listDefaultSelectTag]);
                                props?.setTagListValue([...listDefaultSelectTag])
                            }
                        }
                    }
                );
        }



    }, [props.data, props?.triggerReloadTicket, enableShowMore]);

    useEffect(() => {
        setValidateError(props.data.error);
    }, [props.data]);

    useEffect(() => {
        //remove default empty item with its value = null
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);

        props.setValue(props?.name, [...validTagValues]);
        if (props?.setIsExChangeTagField) {
            props?.setIsExChangeTagField(!props?.isExChangeTagField);
        }
        if (!Utils.isEmptyArray(validTagValues)) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }
        if(firstRender) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }
        if(
            (!firstRender && props?.isEdited) &&
            props.data.structure.required &&
            Utils.isEmptyArray(validTagValues)
        ) {
            setValidateError({
                isError: true,
                message: 'このフィールドは入力必須です。'
            });
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
        } else {
            if(props?.data?.structure?.required) {
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
            } //if it is field required, we will update to change state submit enable or not
            setValidateError(props.data?.error);
        }

    }, [tagValue, firstRender]);

    useEffect(() => {
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);
        if(!Utils.isEmptyString(props.submitTime)){
            if(
                props.data.structure.required &&
                Utils.isEmptyArray(validTagValues)
                ) {
                setValidateError({
                    isError: true,
                    message: 'このフィールドは入力必須です。'
                });
    
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
                
            }
        }
    },[props?.submitTime])

    //listen scroll event list tag items in tag field and load more items.
    useEffect(() => {
        const handleScroll = event => {
            const listboxNode = document.querySelector(
                '.tag-field-multi-select .MuiPaper-root .MuiAutocomplete-listbox'
            );

            if (!listboxNode) return;

            if (
                listboxNode &&
                listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight
            ) {
                return queryLoadMoreMasterTagItems();
            }
        };

        document.addEventListener('scroll', handleScroll, true);

        return () => {
            document.removeEventListener('scroll', handleScroll, true);
        };
    }, [tagList, nextToken]);

    // useEffect(() => {
    //     if (props?.setIsLoading && !isDoneInitData && !props?.isLoading) {
    //         props.setIsLoading(true);
    //     }
    // }, [props?.isLoading, isDoneInitData]);

    const queryLoadMoreMasterTagItems = () => {
        console.log('nextToken to query :>> ', nextToken);
        if (!nextToken || nextToken == 'done') return console.log("loaded");;

        let tagField = argsCommon.tagField;
        switch (tagField.structure.settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                return buildItemTagList(argsCommon, setIsDoneInitData, {
                    userDetail: userDetail,
                    projectDetail: projectDetail,
                    corporationDetail: corporationDetail
                });
            default:
        }
    };

    const renderMasterKnowledgeItemTicket = (itemObj) => {
        return <span className="show-more-button txt-no-hyperlink">{itemObj.title}</span>;
    };

    const formatTagList = fieldTagList => {
        let tagItemList = [];
        for (const field of fieldTagList) {
            let fieldStructure = Utils.convertJSONDataToObject(field?.structure);
            const noOfItem = Number(fieldStructure.no);
            const isShowItemInTicket = fieldStructure.isShowItemInTicket ? true : false;
            tagItemList.push({
                title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name),
                value: field.id,
                no: noOfItem,
                hitNumber: field.hitNumber,
                isShowItemInTicket
            });
        }

        // sort item list by order
        tagItemList = tagItemList.sort((a, b) => {
            return a.no - b.no;
        });
        return tagItemList;
    };

    const sortItemWithHitNumber = (firstItem, secondItem) => {
        if (firstItem.hitNumber > secondItem.hitNumber) {
            return -1;
        }
        if (firstItem.hitNumber < secondItem.hitNumber) {
            return 1;
        }
        if (firstItem.hitNumber === secondItem.hitNumber) {
            if (Number(firstItem.no) < Number(secondItem.no)) {
                return -1;
            } else {
                return 1;
            }
        }
        return 0;
    };

    const getDefaultChecked = () => {
        let indexOfSelectedTag = null
        if(!Utils.isEmptyArray(tagValue)){
            tagList?.forEach((tag,index)=>{
                if(tag.value === tagValue[0].value){
                    indexOfSelectedTag = index
                }
            })
        }
        return indexOfSelectedTag
    }

    const onChangeCheckBoxHandler = e => {
        setFirstRender(false)
        let newTagValue;
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
        }
        if (e.target.checked) {
            const checkedItem = tagList.find(item => item.value === e.target.value);
            newTagValue = cloneDeep([...tagValue, checkedItem]);
            setTagValue([...tagValue, checkedItem]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(newTagValue);
            return newTagValue;
        } else {
            newTagValue = tagValue.filter(item => item.value !== e.target.value);
            setTagValue([...newTagValue]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(tagValue);
            return newTagValue;
        }
    };

    const onChangeRadioButtonHandler = e => {
        setFirstRender(false)
        const index = tagList.findIndex(tag => tag.value === e.target.value);
        const newTagValue = cloneDeep([tagList[index]]);

        if(!isDisableField())
            setTagValue([tagList[index]]);
        
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }

            //using for unchecked radio button
            if ((tagValue[0]?.value === e.target.value || !e.target.value) && !isDisableField()){
                setTagValue([{ value: null }]);
                return Constant.FIELD_UI_SELECT_DEFAULT_ITEM
            }
        }

      

        setDefaultIndexChecked(index);
        return newTagValue;
    };

    const isDisableField = () => {
        if (
            props.data.structure.publicForCustomer == 2 ||
            props.viewFromProjectOfEscalateTicket ||
            !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
            props.hasEditFieldPermissions === false
        )
            return true;
        return false;
    };
   
    const handleOnKeyPressAddItem = e => {
        if (Utils.isEmptyString(e.target.value.trim())) {
            if (e.key === 'Enter') {
                setErrorsAddItem('選択項目を入力してください。');
            }
            return;
        }
        if (e.key === 'Enter') {
            const newItem = {
                title: e.target.value,
                value: `${new Date().getTime()}`,
                isNewItem: true,
                no: tagList.length + 1
            };
            let tagListTemp = tagList;
            if (
                enableShowMore ||
                props.data.structure.optionType === Constant.TAG_FIELD_OPTION_TYPE.SELECT
            ) {
                tagListTemp.push(newItem);

                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(tagListTemp.length);
                    setTagValue([newItem]);
                }
            } else {
                const tagListLength = tagList.length;
                let indexOfNewItem = numOfRecordDisplay;
                if (tagListLength <= numOfRecordDisplay) {
                    indexOfNewItem = tagListLength;
                }
                tagListTemp.splice(indexOfNewItem, 0, newItem);
                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(indexOfNewItem);
                    setTagValue([newItem]);
                }
                setNumOfRecordDisplay(Number(numOfRecordDisplay) + 1);
            }
            if (props?.setIsEdited) {
                if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                props?.setIsEdited(true);
                if(!props?.listFieldEdited?.includes(props?.name)){
                    props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                }
            }
            setTagList([...tagListTemp]);
            setShowAddItemInput(false);
        } else {
            return;
        }
    };

    const enableShowMoreTagList = () => {
        setEnableShowMore(true);
    };
    const isCheckedItem = itemValue => {
        const foundItem = tagValue.find(element => element.value === itemValue);
        if (!Utils.isEmptyObject(foundItem)) {
            return true;
        } else {
            return false;
        }
    };

    const onChangeAddItem = e => {
        setFirstRender(false)
        if (Utils.isEmptyString(e.target.value)) {
            setErrorsAddItem('選択項目を入力してください。');
        } else {
            setErrorsAddItem('');
        }
    };

    const onClickHandler = eventObj => {
        console.log('eventObj :>>---------------- ', eventObj);
        setFirstRender(false)
        let currentTagValue = cloneDeep(tagValue);
        let newTagValue = [];
        switch (eventObj.type) {
            case 'checkBox':
                newTagValue = onChangeCheckBoxHandler(eventObj.value);
                break;
            case 'radio':
                newTagValue = onChangeRadioButtonHandler(eventObj.value);
                break;
            case 'select':
                const oldValue = cloneDeep(tagValue)
                let selectedItems = eventObj.value;
                const userAddedDefaultEmptyItem = _.last(selectedItems)?.value === null;
                const existedDefaultEmptyItem = _.head(selectedItems)?.value === null;

                // clear default empty item when user pick a item
                if (existedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value !== null);

                //if default empty item added to tag value. we will clear other items in list
                if (userAddedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value === null);
                const listSelectedItemHidden = oldValue?.filter(tagMaster => !tagMaster.isDisplay);
                let newValue = [...selectedItems,...listSelectedItemHidden];
                newValue = newValue?.filter(item => !Utils.isEmptyObject(item));
                setTagValue([...newValue]);
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(newTagValue);
                newTagValue = selectedItems;

                if (props?.setIsEdited) {
                    if(props?.setOnChangeEdit){
                            props?.setOnChangeEdit(!props.onChangeEdit)
                        }
                    props?.setIsEdited(true);
                    if(!props?.listFieldEdited?.includes(props?.name)){
                        props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                    }
                }
                break;
            default:
                break;
        }
    };

    const getError = (errorList, name) => {
        if(Utils.isEmptyArray(errorList)) {
            return '';
        }

        if(!errorList[name]) {
            return '';
        }

        return errorList[name].message;
    }


      const handleDelete = value => {
        props?.setIsEdited(true);
        setFirstRender(false);
        let newTagValue = tagValue.filter(option => {
           return option.value !== value
        });
        setTagValue([...newTagValue])
        if(!props?.listFieldEdited?.includes(props?.name)){
            props?.setListFieldEdited([...props.listFieldEdited,props?.name])
        }
        props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(newTagValue);
    }

    return (
        <>
            <div className="form-addTicket">
                <div className="cell-prod-status gap-8">
                    {props?.isTooltipTitle ? 
                        <RenderTooltipTitles {...props}/> :
                        <label className="form-addTicket-label w-f100">{props?.label}{' '}{props.data.structure.required && <span className="required">*</span>}</label>
                    }
                    {props?.isShowIconCopyFieldId && (
                        <Tooltip title={props?.data.id} placement='top' arrow>
                            <img
                                src="/assets/image/icon-copy.svg"
                                alt="copy"
                                onClick={() => navigator.clipboard.writeText(props?.data.id)}
                            />
                        </Tooltip>
                    )}
                </div>
                <div className="form-addTicket-input" data-cy="render-field-menu-tag">
                    <div className="input-item-list">
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            props.data.structure.isMultiple && (
                                <div
                                    className={`${
                                        props.data.structure.publicForCustomer == 2 ||
                                        props.viewFromProjectOfEscalateTicket || 
                                        !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                            ? 'class_disabled autoComplete-disable'
                                            : ''
                                    }`}
                                >
                                    <Autocomplete
                                        PopperComponent={PopperComponentMemo}
                                        multiple
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        filterSelectedOptions
                                        options={tagList.filter(tag => !tag.isDeleted)}
                                        getOptionLabel={option => option.title || ''}
                                        disableCloseOnSelect
                                        getOptionSelected={(option, selectedValue) =>
                                            option.title === selectedValue.title &&
                                            option.value === selectedValue.value
                                        }
                                        value={tagValue?.filter(tag  => tag.isDisplay)}
                                        disabled={
                                            props.data.structure.publicForCustomer == 2 ||
                                            props.viewFromProjectOfEscalateTicket ||
                                            !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                        }
                                        onChange={(e, newValue) => {
                                            setFirstRender(false)
                                            onClickHandler({ type: 'select', value: newValue });
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if (
                                                    !props?.listFieldEdited?.includes(props?.name)
                                                ) {
                                                    props?.setListFieldEdited([
                                                        ...props.listFieldEdited,
                                                        props?.name
                                                    ]);
                                                }
                                                if (props?.setOnChangeEdit) {
                                                    props?.setOnChangeEdit(!props.onChangeEdit);
                                                }
                                            }
                                        }}
                                        renderTags={valueTag => {
                                            return valueTag.map((selecedOption, index) => {
                                                return (
                                                    <CustomToolTitle
                                                            item ={selecedOption}
                                                            argsCommon = {argsCommon}
                                                            key={index}
                                                        >
                                                    <Chip
                                                        label={selecedOption.title}
                                                        id={selecedOption.id}
                                                        className="MuiChip-root setting-title text-truncate"
                                                        onDelete={e => {
                                                            if(!selecedOption.isDeleted){
                                                                handleDelete(selecedOption.value);
                                                            }
                                                            return;
                                                        }}
                                                        disabled={!Utils.isEmptyString(valueTag?.deletedAt)}
                                                    />
                                                    </CustomToolTitle>
                                                );
                                            });
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                className="form-control form-control--wrapSelect form-control--hg40"
                                                error={validateError?.isError}
                                            />
                                        )}
                                        renderOption={option => (
                                            <CustomToolTitle
                                                item={option}
                                                argsCommon={argsCommon}
                                            >
                                               <span
                                                    style={{
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {option.title}
                                                </span>
                                            </CustomToolTitle>
                                        )}
                                        ListboxProps={{
                                            style: { maxHeight: 200, overflow: "auto" }, // Ensure scrolling
                                        }}
                                    />
                                </div>
                            )}
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            !props.data.structure.isMultiple && (
                                <div
                                    className={`${
                                        props.data.structure.publicForCustomer == 2 ||
                                        props.viewFromProjectOfEscalateTicket ||
                                        !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                            ? 'class_disabled autoComplete-disable'
                                            : ''
                                    }`}
                                >
                                    <Autocomplete
                                        PopperComponent={PopperComponentMemo}
                                        options={tagList.filter(tag => !tag.isDeleted)}
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        getOptionLabel={option => option.title || ''}
                                        value={{ ...tagValue?.filter(tag => tag?.isDisplay)[0] }}
                                        getOptionSelected={(option, selectedValue) => {
                                            console.log('selectedValue :>> ', selectedValue,option);
                                            if(selectedValue.value){
                                                return (
                                                    option.title === selectedValue.title &&
                                                    option.value === selectedValue.value
                                                );
                                            }else{
                                                return option.title === selectedValue.title
                                            }
                                        }}
                                        disabled={
                                            props.data.structure.publicForCustomer == 2 ||
                                            props.viewFromProjectOfEscalateTicket ||
                                            !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false 
                                        }
                                        onChange={(e, newValue) => {
                                            setFirstRender(false)
                                            onClickHandler({ type: 'select', value: [newValue] });
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if (
                                                    !props?.listFieldEdited?.includes(props?.name)
                                                ) {
                                                    props?.setListFieldEdited([
                                                        ...props.listFieldEdited,
                                                        props?.name
                                                    ]);
                                                }
                                                if (props?.setOnChangeEdit) {
                                                    props?.setOnChangeEdit(!props.onChangeEdit);
                                                }
                                            }
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                className="form-control form-control--wrapSelect form-control--hg40"
                                                error={validateError?.isError}
                                            />
                                        )}
                                        renderOption={option => (
                                            <CustomToolTitle
                                                item={option}
                                                argsCommon={argsCommon}
                                            >
                                               <span
                                                    style={{
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {option.title}
                                                </span>
                                            </CustomToolTitle>
                                        )}

                                        ListboxProps={{
                                            style: { maxHeight: 200, overflow: "auto" }, // Ensure scrolling
                                          }}
                                    />
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            props.data.structure.isMultiple && (
                                <div className="col-flex">
                                    {tagList.slice(0, numOfRecordDisplay).map((item, i) => {
                                        return (
                                            <div className="col-checkbox" key={i}>
                                                <FormControlLabel
                                                    className="tag-item custom-checkbox"
                                                    control={
                                                        <Checkbox
                                                            onChange={e =>
                                                                {
                                                                    setFirstRender(false)
                                                                    onClickHandler({
                                                                    type: 'checkBox',
                                                                    value: e
                                                                })}
                                                            }
                                                            value={item.value}
                                                            disabled={
                                                                props.data.structure
                                                                    .publicForCustomer == 2 ||
                                                                item.isDeleted ||
                                                                !Utils.isEmptyString(
                                                                    props.detailTicket?.deletedAt
                                                                ) || props.hasEditFieldPermissions === false 
                                                            }
                                                            icon={
                                                                <UnCheckIconWhite
                                                                    isDiabled={
                                                                        props.data.structure
                                                                            .publicForCustomer ===
                                                                            Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                                                                        item.isDeleted ||
                                                                        !Utils.isEmptyString(
                                                                            props.detailTicket
                                                                                ?.deletedAt
                                                                        )
                                                                    }
                                                                />
                                                            }
                                                            checkedIcon={<CheckedIcon />}
                                                            checked={isCheckedItem(item.value)}
                                                        />
                                                    }
                                                    label={
                                                        <CustomToolTitle
                                                            item={item}
                                                            argsCommon={argsCommon}
                                                        >
                                                            <div className="tag-item-label">
                                                                {renderMasterKnowledgeItemTicket(
                                                                    item
                                                                )}
                                                            </div>
                                                        </CustomToolTitle>
                                                    }
                                                    data-cy="render-field-tag-checkbox"
                                                />
                                            </div>
                                        );
                                    })}{' '}
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            !props.data.structure.isMultiple && (
                                <RadioGroup
                                    row
                                    aria-label=""
                                    name="radio-buttons-group"
                                    onChange={e => {
                                        setFirstRender(false)
                                        }
                                    }
                                    onClick={e=>{
                                        onClickHandler({ type: 'radio', value: e })
                                    }}
                                >
                                    {tagList.slice(0, numOfRecordDisplay).map((item, i) => (
                                        <FormControlLabel
                                            value={item.value}
                                            className="tag-item custom-radio"
                                            control={
                                                <Radio
                                                    disabled={
                                                        props.data.structure.publicForCustomer ==
                                                            2 ||
                                                        props.viewFromProjectOfEscalateTicket ||
                                                        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
                                                        item.isDeleted || props.hasEditFieldPermissions === false 
                                                    }
                                                    checked={
                                                        i === getDefaultChecked() ? true : false
                                                    }
                                                />
                                            }
                                            label={
                                                <CustomToolTitle
                                                            item ={item}
                                                            argsCommon = {argsCommon}
                                                        >
                                                    <div className="tag-item-label">
                                                        {renderMasterKnowledgeItemTicket(item)}
                                                    </div>
                                                </CustomToolTitle>
                                            }
                                            key={i}
                                        />
                                    ))}
                                </RadioGroup>
                            )}
                        {validateError?.isError &&
                            Utils.isEmptyString(getError(props.errorlist, props.name)) && (
                                <>
                                    <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                        {validateError.message}
                                    </p>
                                </>
                            )}
                        {getError(props.errorlist, props.name) && (
                            <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                {getError(props.errorlist, props.name)}
                            </p>
                        )}

                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            (enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                    </div>
                    <div className="tag-field-control">
                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            !(
                                enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT
                            ) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                        {/* {isPermissionAddItemTag &&
                            props.data.structure.publicForCustomer != 2 &&
                            props.data.definition !==
                                Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD && (
                                <Button
                                    onClick={() => {
                                        setShowAddItemInput(true);
                                    }}
                                    className="btn-addItem-right"
                                    variant="contained"
                                    color="primary"
                                >
                                    +
                                </Button>
                            )} */}
                        {!enableShowMore &&
                            props.data.structure.publicForCustomer != 2 &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT && tagList.length > numOfRecordDisplay && (
                                <Box
                                    className={
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? 'show-more-button link-file-name'
                                            : 'disable-show-more-button'
                                    }
                                    onClick={e =>
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? enableShowMoreTagList()
                                            : e.preventDefault()
                                    }
                                    data-cy="render-field-tag-seemore"
                                >
                                    もっと見る
                                </Box>
                            )}
                    </div>
                </div>
            </div>
        </>
    );
}
